/* eslint-disable react-hooks/exhaustive-deps */
import { BarChart } from 'components'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { all as allDrawer } from 'store/Sidebar/Sidebar.selector'
import { traceabilityTablesActions } from 'store/TraceabilityTables'
import { all } from 'store/TraceabilityTables/TraceabilityTables.selector'
import * as S from './styled'
import { ThemeContext } from 'App'
import { THEMES } from 'themes'

export function ChartSIF() {
  const { currentTheme } = useContext(ThemeContext)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const monthsTranslate = t('common:months')

  const { sifByMonth, chartsLoading, filters } = useSelector(all)
  const { persistent } = useSelector(allDrawer)

  const sifProductionSeries = {
    name: monthsTranslate,
    data: sifByMonth
  }

  useEffect(() => {
    if (filters.begin && filters.end && !chartsLoading) {
      dispatch(
        traceabilityTablesActions.getKpisCharts({
          ...filters,
          charts: ['sifByMonth'],
          years: filters.years.length
            ? filters.years
            : [new Date().getFullYear()]
        })
      )
    }
  }, [dispatch, filters])

  return (
    <S.Wrapper item xs={12} md={12} container>
      <S.GridHorizontalDate item xs={12}>
        <BarChart
          color={THEMES[currentTheme].colors.chartBarColor}
          type="column"
          title=""
          subTitle=""
          series={sifProductionSeries}
          tooltipSuffix={t('common:sifs')}
          isLoading={chartsLoading}
          width={persistent === false ? 800 : 645}
        />
      </S.GridHorizontalDate>
    </S.Wrapper>
  )
}
